import { ChainId } from '@ui/types/chain';
import { getContract, PublicClient, WalletClient } from 'viem';

import TradingReaderFacet from '../abis/TradingReaderFacet';
import { getContractAddress } from '../constants';

export const getTradingReaderFacet = ({
  publicClient,
  walletClient,
  chainId,
}: {
  publicClient: PublicClient;
  walletClient?: WalletClient;
  chainId: ChainId;
}) => {
  const address = getContractAddress('LeverUp', chainId);
  if (!address) throw new Error('Contract address not found');

  return getContract({
    abi: TradingReaderFacet,
    address: address,
    client: {
      public: publicClient,
      wallet: walletClient,
    },
  });
};
